import styled from 'styled-components';
import Typography from '@klv/atoms/typography';
import type { IColorVariants } from '@klv/molecules/features-item/types';

export const StyledFeaturesList = styled.section<IColorVariants>`
  ${({ theme, $variant }) => `
    ${theme.globalPadding};
    background-color: ${theme?.featuresList[$variant].background};
  `}
`;
export const FeaturesHeader = styled.header`
  ${({ theme }) => `
    grid-column: 1 / -1;
    margin-bottom: .8rem;
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: 1 / 10;
      margin-bottom: 3.8rem;
    }
  `}
`;
export const StyledHeadline = styled(Typography)`
  margin-bottom: 2.4rem;
`;
export const StyledBody = styled(Typography)`
  ${({ theme }) => `
    ${theme.screenSize.s768.mediaQuery} {
      margin-bottom: 3.3rem;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      margin-bottom: 0;
    }
  `}
`;
export const ButtonContainer = styled.div`
  ${({ theme }) => `
    grid-column: 1 / -1;
    margin-top: 4.45rem;
    text-align: center;
    ${theme.screenSize.s1024.mediaQuery} {
      grid-column: 6 / 12;
      text-align: left;
      margin-top: 8rem;
    }
  `}
`;
